import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { SkeletonRows } from '@components/table';
import { EmptyRow } from '@components/table/EmptyRow';
import { fonts } from '@theme/fontsCustomer';
import type { TenantSsoProviderModel } from '@repositories/tenantSsoProviderRepository/models/TenantSsoProviderModel';
import { SsoProviderTableRow } from './SsoProviderTableRow';

type Props = {
  providers: TenantSsoProviderModel[];
  isLoading: boolean;
};

const COLUMN_COUNT = 5;

export const SsoProviderTable = ({ providers, isLoading }: Props) => {
  const { t } = useTranslation();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledHeadCell align="left">{t('SsoProvider.table.providerName')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('SsoProvider.table.registrationId')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('SsoProvider.table.issuerUri')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('SsoProvider.table.status')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('SsoProvider.table.createdDate')}</StyledHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <SkeletonRows rowNum={3} colNum={COLUMN_COUNT} />
          ) : providers.length === 0 ? (
            <EmptyRow colSpan={COLUMN_COUNT} title={t('SsoProvider.empty')} />
          ) : (
            providers.map(provider => (
              <SsoProviderTableRow key={provider.id} provider={provider} />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const StyledHeadCell = styled(TableCell)`
  ${fonts.Body4};
  color: ${({ theme: { colors } }) => colors['text-gray-sub-dark']};
  background-color: ${({ theme: { colors } }) => colors['bg-gray-lighter']};
`;
